import { makeStyles } from 'tss-react/mui';

const useStylesRightDrawerContentItem: MaterialUIStylesCallback = makeStyles()((
  theme: MainTheme,
): MaterialUIStyles => ({
  rightDrawerContentItem: {
    padding: 15,
  },
  rightDrawerContentItemFeed: {
    marginBottom: 5,
    backgroundColor: `${theme.palette.common.black} !important`,
    color: `${theme.palette.common.white} !important`,
    cursor: 'pointer',
  },
  rightDrawerContentItemHeader: {
    padding: '0 !important',
  },
  rightDrawerContentItemHeaderSubTitle: {
    marginTop: '5px !important',
  },
  rightDrawerContentItemHeaderImageAvatar: {
    margin: '10px 10px auto 10px',
  },
  rightDrawerContentItemHeaderImageFeed: {
    margin: 'auto 10px',
  },
  rightDrawerContentItemSubjectBlock: {
    margin: 10,
  },
  rightDrawerContentItemMarkBlock: {
    marginTop: 3,
    marginRight: 5,
  },
  rightDrawerContentItemRichTextBlock: {
    marginTop: 10,
    marginLeft: 10,
  },
}));

export default useStylesRightDrawerContentItem;
